import { LabDashboardPage } from "./LabDashboardPage";

const LabDashboard = (props: {}) => {
	return <LabDashboardPage />;
};
export default LabDashboard;
